import { Card } from '@digdir/designsystemet-react';

import styled from '../../../../../../styled';

export const FormCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;
